var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',[_c('el-col',[_c('Title',{attrs:{"title":"Importar puntos","subtitle":"Carga por archivo puntos geocodificados"}})],1),_c('el-col',[_c('upload',{attrs:{"maxSize":2}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }